import { render, staticRenderFns } from "./BaseSegmentedControl.vue?vue&type=template&id=2b3859a0&scoped=true&"
import script from "./BaseSegmentedControl.vue?vue&type=script&lang=ts&"
export * from "./BaseSegmentedControl.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSegmentedControl.vue?vue&type=style&index=0&id=2b3859a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3859a0",
  null
  
)

export default component.exports